import {Tooltip, makeStyles} from '@material-ui/core';

// override mui style
function CustomTooltip(props) {
  const style = makeStyles((theme) => ({
    tooltip: {
      fontSize: 16
    }
  }))(Tooltip);
  
  return <Tooltip classes={style} {...props}/>
}

export default CustomTooltip;